/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { ExternalStyles, Heading, Text, Theme, useTheme, VFlow } from 'bold-ui'

import { PassouFalhouEnum } from '../model-consultaSeguimento'
import { ConsultaSeguimentoExemplosHorizontalPinDown } from './ConsultaSeguimentoExemplosHorizontalPinDown'
import { ConsultaSeguimentoPinDown } from './ConsultaSeguimentoPinDown'

type ConnectorVariant = 'default' | 'horizontal'

export type ConsultaSeguimentoIndicatorResultadoText = Partial<Record<PassouFalhouEnum, string>>

interface ConsultaSeguimentoIndicatorResultadoProps {
  resultado: PassouFalhouEnum
  connectorVariant?: ConnectorVariant
  text?: ConsultaSeguimentoIndicatorResultadoText
  style?: ExternalStyles
}

export function ConsultaSeguimentoIndicatorResultado(props: Readonly<ConsultaSeguimentoIndicatorResultadoProps>) {
  const { resultado, connectorVariant = 'default', text, style } = props

  const theme = useTheme()
  const styles = createStyles(theme, connectorVariant)

  return (
    <div css={[styles.root]}>
      {connectorVariant === 'default' && (
        <ConsultaSeguimentoPinDown style={[styles.connector, styles.connectorStatus[resultado]]} />
      )}
      {connectorVariant === 'horizontal' && (
        <ConsultaSeguimentoExemplosHorizontalPinDown style={[styles.connector, styles.connectorStatus[resultado]]} />
      )}
      <VFlow vSpacing={0} style={[styles.box, styles.boxStatus[resultado], style]}>
        {text?.[resultado] && <Text color='inherit'>{text[resultado]}</Text>}
        <Heading level={3} color='inherit'>
          {resultado === PassouFalhouEnum.PASSOU ? 'Passou' : 'Falhou'}
        </Heading>
      </VFlow>
    </div>
  )
}

const createStyles = (theme: Theme, connectorVariant: ConnectorVariant) => ({
  root: css`
    display: grid;
    justify-self: center;
    justify-items: center;
  `,
  connector: css`
    transform: translateZ(0);
  `,
  connectorStatus: {
    [PassouFalhouEnum.PASSOU]: css`
      color: ${theme.pallete.status.success.c60};
    `,
    [PassouFalhouEnum.FALHOU]: css`
      color: ${theme.pallete.status.danger.c60};
    `,
  },
  box: css`
    align-items: center;
    padding: 0.5rem 1rem;
    border-radius: 0.25rem;
    margin-top: ${connectorVariant === 'default' ? '-0.325rem' : '-0.375rem'};
    text-align: center;
  `,
  boxStatus: {
    [PassouFalhouEnum.PASSOU]: css`
      color: ${theme.pallete.status.success.c40};
      background: ${theme.pallete.status.success.c90};
    `,
    [PassouFalhouEnum.FALHOU]: css`
      background: ${theme.pallete.status.danger.c90};
      color: ${theme.pallete.status.danger.c40};
    `,
  },
})
